import { render } from "./OffcanvasComponent.vue?vue&type=template&id=23bf397f&ts=true"
import script from "./OffcanvasComponent.vue?vue&type=script&lang=ts"
export * from "./OffcanvasComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__